module.exports = __webpack_public_path__ + "static/media/civil-right.a6570388.svg";